import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/imports_/new')({
  staticData: { title: 'Import' },
})
